import React, {createContext, useContext, useEffect, useReducer, useState} from 'react';
import HideAppBar from "../../../widgets/header/HideAppBar";
import {Container} from "@mui/material";
import Grid from "@mui/material/Grid";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useParams} from "react-router-dom";
import AnagraficaAccordion from "../../focolai/detail/AnagraficaAccordion";
import {getProtocolloById, getQuarantenaHistory, updateProtocollo} from "../../../../services/QuaranteneServices";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import QuarantenaInfoCard from "../../quarantene/detail/QuarantenaInfoCard";
import HistoryCard from "../../quarantene/detail/HistoryCard";
import ProtocolloDetailCard from "./ProtocolloDetailCard";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AppContext} from "../../../../App";

export const ProtocolliContext = createContext();

const ProtocolloDetailPage = () => {
	const classes = BaseStyle();
	let {id} = useParams();
	const appContext = useContext(AppContext);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [backOk, setBackOk] = useState(false);
	const [submitGoBack, setSubmitGoBack] = useState(false)
	
	const backFunction = () => {
		setSubmitGoBack(true);
		updateProtocollo({...quarantenaState.protocollo}, quarantenaDispatch);
	}
	
	useEffect(() => {
		if (submitGoBack && !quarantenaState.loadingUpdateProtocollo && quarantenaState.errorUpdateProtocollo === "") {
			setSubmitGoBack(false)
			setBackOk(true);
		} else if (submitGoBack && !quarantenaState.loadingUpdateProtocollo && quarantenaState.errorUpdateProtocollo !== "") {
			setSubmitGoBack(false)
			setOpenSnackbar("error", quarantenaState.errorUpdateProtocollo, appContext.dispatch);
		}
	}, [submitGoBack, quarantenaState.loadingUpdateProtocollo, quarantenaState.errorUpdateProtocollo, appContext.dispatch])
	
	useEffect(() => {
		getProtocolloById(id, quarantenaDispatch);
	}, [id, quarantenaDispatch])
	
	useEffect(() => {
		if (!quarantenaState.loadingGetProtocollo && quarantenaState.errorGetProtocollo === "") {
			getQuarantenaHistory(quarantenaState.protocollo?.quarantena?.id, quarantenaDispatch);
		}
	}, [quarantenaState.loadingGetProtocollo, quarantenaState.errorGetProtocollo, quarantenaDispatch, quarantenaState.protocollo])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
		<React.Fragment>
			<ProtocolliContext.Provider value={{state: quarantenaState, dispatch: quarantenaDispatch}}>
				<main className={classes.main}>
					<HideAppBar title={"Protocollo " + id} back={true} backOk={backOk} backFunction={backFunction}
					            backPosition={false} useBackOk={true}/>
					<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
						<Grid container spacing={3}>
							
							<Grid item xs={12} md={6}>
								<Grid container spacing={3} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
									<Grid item xs={12}>
										{
											quarantenaState.loadingGetProtocollo ? <Skeleton/> :
												quarantenaState.errorGetProtocollo !== "" ? "Err ..." :
													<AnagraficaAccordion quarantena={quarantenaState.protocollo?.quarantena}/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											quarantenaState.loadingGetProtocollo ? <Skeleton/> :
												quarantenaState.errorGetProtocollo !== "" ? "Err ..." :
													<DiarioPaziente idSoggetto={quarantenaState.protocollo?.anagrafica?.idSoggetto}/>
										}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item xs={12} md={6}>
								<Grid container spacing={3} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
									<Grid item xs={12}>
										{
											quarantenaState.loadingGetProtocollo ? <Skeleton/> :
												quarantenaState.errorGetProtocollo !== "" ? "Err ..." :
													<ProtocolloDetailCard/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											quarantenaState.loadingGetProtocollo ? <Skeleton/> :
												quarantenaState.errorGetProtocollo !== "" ? "Err ..." :
													<QuarantenaInfoCard quarantena={quarantenaState.protocollo?.quarantena}
													                    tipoQuarantena={quarantenaState.protocollo?.quarantena?.tipo}/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											quarantenaState.loadingGetQuarantenaHistory ? <Skeleton/> :
												quarantenaState.errorGetQuarantenaHistory !== "" ?
													<Alert severity="error" style={{borderRadius: 24}}>
														<AlertTitle>Errore</AlertTitle>
														Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta
														gli sviluppatori.
													</Alert> :
													quarantenaState.loadingGetProtocollo ? <Skeleton/> :
														quarantenaState.errorGetProtocollo !== "" ? "Err ..." :
															<HistoryCard storico={quarantenaState.quarantenaHistory}
															             quarantena={quarantenaState.protocollo?.quarantena}/>
										}
									</Grid>
								</Grid>
							</Grid>
						
						</Grid>
					</Container>
				</main>
			</ProtocolliContext.Provider>
		</React.Fragment>
	);
};

export default React.memo(ProtocolloDetailPage)
